"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LandingWrap = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.LandingWrap = styled_components_1.default.div `
  background: linear-gradient(
    179.61deg,
    #9462f4 15.33%,
    #7171f2 54.82%,
    #73aaf9 93.49%
  );
  &,
  * {
    box-sizing: border-box;
  }

  h1 {
    font-family: Phenomena, sans-serif;
    text-align: left;
    color: #ffffff;
    font-size: 24px;
    font-weight: 700;
    line-height: 24px;
    margin: 0;

    @media screen and (min-width: 768px) {
      font-size: 40px;
      line-height: 48px;
    }

    @media screen and (min-width: 1000px) {
      line-height: 48px;
    }

    @media screen and (min-width: 1300px) {
      font-size: 52px;
      line-height: 62px;
    }

    @media screen and (min-width: 1690px) {
      font-size: 58px;
      line-height: 70px;
    }

    @media screen and (min-width: 1920px) {
      font-size: 64px;
      line-height: 77px;
    }
  }
`;
